export const purposes = {
    PERSONAL_JOURNEY: 'PERSONAL_JOURNEY',
    BUSINESS_JOURNEY: 'BUSINESS_JOURNEY',
};

export const purposeTexts = {
    [purposes.PERSONAL_JOURNEY]: 'Privatfahrt',
    [purposes.BUSINESS_JOURNEY]: 'Geschäftsreise',
};
